





















































import { Component, Prop, Vue } from 'vue-property-decorator'

@Component({})
export default class InfoBox extends Vue {
	@Prop({ default: false })
	private isError!: boolean

	@Prop({ default: false })
	private isTransparent!: boolean

	@Prop({ default: 'info' })
	private iconName!: string

	@Prop({ default: '' })
	private text!: string

	@Prop({ default: '' })
	private linkText!: string
}
